<template>
  <invoice-list :cate="cate" ref="invoiceList"></invoice-list>
</template>

<script>
import InvoiceList from "./InvoiceList.vue";
export default {
  components: {
    InvoiceList,
  },
  data() {
    return {
      cate: "Sales", //平台跟承运人
    };
  },
  mounted() {
    this.$refs.invoiceList.init();
  },
};
</script>